// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2k_tz";
export var title = "styles-module--title--aR1KQ";
export var image = "styles-module--image--19jQG";